import React, { useState } from "react";
import ContentHeader from "../../components/ContentHeader";
import FlexLayout from "../../components/LayoutFlex";
import { Flex, Box, Text, Heading } from "@edricphan2022/uikit";
import Picture from "../../components/Picture";
import styled from "styled-components";
import Logo from "../../assets/About/Logoffffff.png";
import Crilce from "../../assets/About/cricle.png";

import IconWithArr from "../../components/IconOrbit/IconWithArr";

// import { SharIcon, NetWorkIcon, KeepIcon } from "@edricphan2022/uikit";

import OurChange1 from "../../assets/About/ImagebackgroundAbout.png";
import OurChange2 from "../../assets/About/OurChanges2.png";
const OurChange = () => {

  return (
    <Wrapper>
      <h1>Our Changes </h1>
      <BoxImgGroup>
        <BoxImg>
          <img src={OurChange2} alt="" />
          <BoxLogo>
            <img src={Logo} alt=''/>
            <img src={Crilce} alt = ''/>
          </BoxLogo>
        </BoxImg>
        <BoxImg>
          <img src={OurChange1} alt="" />
          <BoxLogo>
            <img src={Logo} alt=''/>
            <img src={Crilce} alt = ''/>
          </BoxLogo>
        </BoxImg>
      </BoxImgGroup>
    </Wrapper>
  );
};

const Wrapper = styled(Box)`
  width: 100%;
  h1{
    font-size: 40px;
    font-weight: 700;
    font-family: ManropeBold;
    color: #333333;
    margin-bottom: 42px;
  }
`
const BoxImgGroup = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  @media only screen and (max-width: 743px){
    flex-direction: column;
  }
`
const BoxImg = styled(Box)`
  width: 49.5%;
  min-width: 49.5%;
  border-radius:22px;
  position: relative;
  overflow: hidden;
  :nth-child(1){
    margin-right: 1%;
  }
  img{
    width: 100%;
    border-radius: 22px;
  }
  @media only screen and (max-width: 743px){
    width: 100%;
    :nth-child(1){
      margin-bottom: 30px;
    }
  }
`
const BoxLogo = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5.59%;
  background-color: #F7D644;
  position: absolute;
  width: 100%;
  height: 38.2%;
  max-height: 38.2%;
  border-radius: 0px 0px 22px 22px;
  bottom: 0px;
  right: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  img{
    :nth-child(1){
      width: 29%;
    }
    :nth-child(2){
      width: 24%;
    }
  }
`

export default OurChange;
